module.exports = __webpack_public_path__ + "static/media/everyday_health_icon.0e81eba1.svg";